import PropTypes from 'prop-types';
import React from 'react';
import bindAll from 'lodash.bindall';
import styles from './badgeRanking.module.css';
import first from '../../../img/ic_medal_gold.png';
import secoond from '../../../img/ic_medal_silver.png';
import third from '../../../img/ic_medal_bronze.png';
import defaultImg from '../../../img/bee.png';
import {FILE_URL} from "../../../util/constants";

import {getHzDzHonorListRequest} from "../../../service/report";

class BadgeRanking extends React.Component {
    constructor(props) {
        super(props);
        bindAll(this, [
            'handleImageErrored'
        ]);

        this.state = {
            huizhangList:[],
            name1:'',
            badge1:'',
            img1:'',
            name2:'',
            badge2:'',
            img2:'',
            name3:'',
            badge3:'',
            img3:''
        };

    }

    componentDidMount() {
        getHzDzHonorListRequest(sessionStorage.getItem('studentpid'), (data) => {
            console.log(data)

            if (data.ret == '1') {
                // this.setState({
                //     name1:data.data.huizhang[0].name,
                //     badge1:data.data.huizhang[0].badge,
                //     img1:FILE_URL + data.data.huizhang[0].img,
                //     name2:data.data.huizhang[1].name,
                //     badge2:data.data.huizhang[1].badge,
                //     img2:FILE_URL + data.data.huizhang[1].img,
                //     name3:data.data.huizhang[2].name,
                //     badge3:data.data.huizhang[2].badge,
                //     img3:FILE_URL + data.data.huizhang[2].img
                // });
                if (data.data.huizhang.length == 1) {
                    this.setState({
                        name1: data.data.huizhang[0].name,
                        badge1: data.data.huizhang[0].badge,
                        img1: FILE_URL + data.data.huizhang[0].img,
                        name2: '无',
                        badge2: 0,
                        img2: defaultImg,
                        name3: '无',
                        badge3: 0,
                        img3: defaultImg,
                    });
                }
                if (data.data.huizhang.length == 2) {
                    this.setState({
                        name1: data.data.huizhang[0].name,
                        badge1: data.data.huizhang[0].badge,
                        img1: FILE_URL + data.data.huizhang[0].img,
                        name2: data.data.huizhang[1].name,
                        badge2: data.data.huizhang[1].badge,
                        img2: FILE_URL + data.data.huizhang[1].img,
                        name3: '无',
                        badge3: 0,
                        img3: defaultImg,
                    });
                }
                if (data.data.huizhang.length == 3) {
                    this.setState({
                        name1: data.data.huizhang[0].name,
                        badge1: data.data.huizhang[0].badge,
                        img1: FILE_URL + data.data.huizhang[0].img,
                        name2: data.data.huizhang[1].name,
                        badge2: data.data.huizhang[1].badge,
                        img2: FILE_URL + data.data.huizhang[1].img,
                        name3: data.data.huizhang[2].name,
                        badge3: data.data.huizhang[2].badge,
                        img3: FILE_URL + data.data.huizhang[2].img
                    });
                }
            }
        });
    }

    componentDidUpdate() { // 组件更新后触发


    }

    componentWillUnmount (){

    }

    handleImageErrored(index){

        if(index==1){
            this.setState({
                img1:defaultImg
            });
        } if(index==2){
            this.setState({
                img2:defaultImg
            });
        } if(index==3){
            this.setState({
                img3:defaultImg
            });
        }


    }

    render() {

        return (
            <div className={styles.root} id='test2'>

                <div className={styles["text-green"]}>徽章荣誉榜</div>

                <div className={styles["container-rank"]}>
                    <div className={styles.div2}>
                        <div className={styles["container-touxiang2"]}>
                            <img className={styles["img-second"]} src={this.state.img2} onError={this.handleImageErrored.bind(this, 2)}/>
                        </div>
                        <div className={styles["text-red"]}>{this.state.badge2}</div>
                        <div className={styles["text-blue"]}>{this.state.name2}</div>
                    </div>
                    <div className={styles.div1}>
                        <div className={styles["container-touxiang"]}>
                            <img className={styles["img-first"]} src={this.state.img1} onError={this.handleImageErrored.bind(this, 1)}/>
                        </div>

                        <div className={styles["text-red"]}>{this.state.badge1}</div>
                        <div className={styles["text-blue"]}>{this.state.name1}</div>
                    </div>
                    <div className={styles.div3}>
                        <div className={styles["container-touxiang3"]}>
                            <img className={styles["img-second"]} src={this.state.img3} onError={this.handleImageErrored.bind(this, 3)}/>
                        </div>
                        <div className={styles["text-red"]}>{this.state.badge3}</div>
                        <div className={styles["text-blue"]}>{this.state.name3}</div>
                    </div>

                </div>
            </div>
        )
    }
}


export default BadgeRanking;
